// Theming options can be found here:
// https://v2.chakra-ui.com/docs/components/stepper/theming

const BORDER_PROPS = {
  borderColor: "brand.clear_creek",
};

const BACKGROUND_COMLETE_PROPS = {
  background: "brand.clear_creek",
};

export const STEPPER_STYLES = {
  baseStyle: {
    indicator: {
      "[data-status=complete] &": { ...BORDER_PROPS, ...BACKGROUND_COMLETE_PROPS },
      "[data-status=active] &": BORDER_PROPS,
    },
    separator: {
      "[data-status=complete] &": BACKGROUND_COMLETE_PROPS,
    },
    number: {
      "[data-status=complete] &": { color: "brand.bg" },
      "[data-status=active] &": { color: "brand.clear_creek" },
      "[data-status=incomplete] &": { color: "gray.300" },
    },
  },
};
